import React, { useEffect, useState } from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom'
import Card from '../../components/Card/Card';
import DataTable from '../../components/DataTable/DataTable';
import { IColInfo } from '../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../contexts/authContext';
import { useNotifications } from '../../contexts/notificationContext';
import DataService from "../../services/data.service";

const RoyaltyTypes: React.FC = () => {
    const [data, setData] = useState<any[]>();
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedFor } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        getTableData();
    }, []);

    function getTableData() {
        DataService.get<any[]>('api/v1/royaltytypes')
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function add() {
        navigate('/plm/itemsetup/royaltytype/add', { state: { title: 'New royaltytype', fromMenu: false } });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/royaltytypes/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    const colInfos: IColInfo[] = [
        { title: 'ID', key: true, dataProp: 'id', dataType: 'number' },
        { title: 'Code', dataProp: 'referenceCode', sort: 'asc', filterInfo: { filterType: 'Textbox' } },
        { title: 'Name', dataProp: 'name', filterInfo: { filterType: 'Textbox' } },
        { title: 'Begin', dataProp: 'beginDate', dataType: 'date' },
        { title: 'End', dataProp: 'endDate', dataType: 'date' },
    ];
    if (isAuthorizedFor(ApplicationFunctions.EditRoyaltyTypes)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: add }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }],
            });
    }

    return (
        <>
            <div className='main-content'>
                <Container fluid>
                    <Row>
                        <Col md={12}>
                            <Card title='Royaltytypes'
                                content={
                                    <DataTable
                                        name='dtRoyaltyTypes'
                                        tableData={data}
                                        colInfos={colInfos}
                                        navigateTitle='Royaltytype'
                                        navigateUrl='/plm/itemsetup/royaltytype/'
                                    />
                                }
                            />
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
}
export default RoyaltyTypes;